import moment from "moment-timezone";

const DISPLAY_TZ = "Asia/Kolkata";

/** Date + Time */
export const formatDateTime = (
    date,
    format = "DD/MM/YYYY hh:mm A"
) => {
    if (!date) return "-";
    return moment.utc(date).tz(DISPLAY_TZ).format(format);
};